import { ActionTypes } from "../actions/types";

const INITIAL_STATE = {};

export const carrouselReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case "UPDATE_CARROUSEL_ACTIVE_VARIABLE":
            if (!state[action.instanceId]) {
                // Initialize the state for new instanceId
                return {
                    ...state,
                    [action.instanceId]: {
                        activeVariableIndex: action.activeVariableIndex,
                        isPrevBtnActive: action.isPrevBtnActive,
                        isNextBtnActive: action.isNextBtnActive,
                    },
                };
            }
            // Update the state for existing instanceId
            return {
                ...state,
                [action.instanceId]: {
                    ...state[action.instanceId],
                    activeVariableIndex: action.activeVariableIndex,
                    isPrevBtnActive: action.isPrevBtnActive,
                    isNextBtnActive: action.isNextBtnActive,
                },
            };
        default:
            return state;
    }
};
